/*
 * BuroEcl
 * Copyright (c) 2023 Buroclic. All rights reserved.
 * 
 * This file corresponds to the sidebar
 * containing the menu
 */

// Imports
import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

// Interfaces
import { PublicCabinet } from '../../interfaces/ICabinets';

// Sidebar sub-components
import { SideBarFolderMenu } from './SideBarFolderMenu';
import { SideBarMySpaceMenu } from './SideBarMySpaceMenu';

// Buroclic adaptive components
import { PoweredByBc } from '../buroclic/PoweredByBc';

export const SideBar = (props) => {
    const [isExpanded, setIsExpanded] = useState(props.expanded || true); // Menu expand

    // Update expanded parent state
    /* eslint-disable */
    useEffect(() => {
        if (props.setExpanded)  props.setExpanded(isExpanded);
    }, [isExpanded])
    /* eslint-enable */

    // Get whether or not a folder has been provided in order to know if we'll have to refresh/display some additional data
    const hasFolderBeenProvided :boolean = Object.keys(props.dossier).length > 0;

    const cabinet = (JSON.parse(localStorage.getItem('cabinet') || "{}") as PublicCabinet);

    // JSX Template
    return (
        <div className={`bg-gray-100 flex-grow flex flex-row justify-between items-start h-[inherit] ${isExpanded ? 'w-fit min-w-content grow w-min' : 'min-w-[60px] w-[60px]'}`}>

            <div className='flex flex-col w-full h-full flex-grow relative'>
                {/* SideBar */}
                <div className={`mx-[14px] grow mt-4 min-w-[32px] flex-grow duration-0 flex flex-col ${!isExpanded ? 'w-full place-items-center max-w-[32px]' : 'w-max'}`}>

                    {/* Burger Menu icon */}
                    <div className="flex flex-row items-center">
                        <FontAwesomeIcon className="mb-2 w-8 h-8 cursor-pointer" onClick={() => setIsExpanded(!isExpanded)} icon={faBars} />
                    </div>


                    {/* Folder's category Menu (displayed if a folder has already been selected) */}
                    {hasFolderBeenProvided && <SideBarFolderMenu key={`foldermenu-${props.dossier.DOS_REF}-${isExpanded ? 'expanded' : ''}`} expanded={isExpanded} setExpanded={setIsExpanded} changeRenderedComponent={props.changeRenderedComponent} cabinet={cabinet}
                    mission={props.mission || {}} missions={props.missions} missionHandler={props.missionHandler} missionsExpanded={props.missionsExpanded} setMissionsExpanded={props.setMissionsExpanded}
                    chemise={props.chemise || {}} chemises={props.chemises} chemiseHandler={props.chemiseHandler} chemisesExpanded={props.chemisesExpanded} setChemisesExpanded={props.setChemisesExpanded} />}


                    {/* Customer's space category Menu */}
                    {hasFolderBeenProvided && <hr className={`my-1 border-1 opacity-100 rounded-lg w-full mx-auto`} style={{ borderColor: cabinet.color }} />}
                    {/*{hasFolderBeenProvided && isExpanded && <h3 className='text-left mt-1 font-semibold'>Mon espace</h3>}*/}
                    <SideBarMySpaceMenu key={`myspacemenu-${isExpanded ? 'expanded' : ''}`} expanded={isExpanded} setExpanded={setIsExpanded} changeRenderedComponent={props.changeRenderedComponent} cabinet={cabinet} dossier={props.dossier} />
                    
                </div>
                <PoweredByBc className={`p-2 ${!isExpanded ? 'hidden': ''} `} imgClassName={'max-h-12 max-w-12 object-contain object-center m-auto top-4'} />
            </div>

            
        </div >
    );
};

// Properties definition
SideBar.propTypes = {
    expanded: PropTypes.bool, // State of the sidebar (expanded or not)
    setExpanded: PropTypes.func, // Set the parent state of expanded
    changeRenderedComponent: PropTypes.func.isRequired, // Change the content to be rendered
    dossier: PropTypes.object.isRequired, // selected dossier

    // Folder-relative props
    mission: PropTypes.object,
    missions: PropTypes.arrayOf(PropTypes.object),
    missionHandler: PropTypes.func,
    missionsExpanded: PropTypes.bool,
    setMissionsExpanded: PropTypes.func,
    chemise: PropTypes.object,
    chemises: PropTypes.arrayOf(PropTypes.object),
    chemiseHandler: PropTypes.func,
    chemisesExpanded: PropTypes.bool,
    setChemisesExpanded: PropTypes.func,
    
    // Appearance
    className: PropTypes.string
}